import { AdamantemBadge } from "@/components/AdamantemPanel";

// Grupo de un lanzamiento para contar y filtrar: en tiendas, por corregir, en revisión o rechazado.
export const BUCKETS = [
  { key: "all", label: "Todos" },
  { key: "tiendas", label: "Enviados" },
  { key: "revision", label: "En revisión" },
  { key: "corregir", label: "Por corregir" },
  { key: "rechazado", label: "Rechazados" },
];

export function bucketOf(r) {
  const st = r?.distribution_state;
  if (st === "forwarded") return "tiendas";
  if (st === "rejected" || st === "error") return "rechazado";
  if (!st && r?.review_status === "needs_fix") return "corregir";
  return "revision";
}

export function countBuckets(rows) {
  const c = { all: rows.length, tiendas: 0, revision: 0, corregir: 0, rechazado: 0 };
  rows.forEach((r) => { c[bucketOf(r)] += 1; });
  return c;
}

export function StatusCell({ r }) {
  if (r?.distribution_state) return <AdamantemBadge state={r.distribution_state} />;
  if (r?.review_status === "needs_fix") return <span className="inline-block whitespace-nowrap rounded-full border border-red-200 bg-red-50 px-2.5 py-0.5 text-[11px] font-semibold text-red-700">Por corregir</span>;
  if (r?.review_status === "manual") return <span className="inline-block whitespace-nowrap rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-[11px] font-semibold text-amber-700">Revisión del equipo</span>;
  return <span className="whitespace-nowrap text-xs text-slate-400">En revisión en Always Fresh</span>;
}

export function BucketTabs({ rows, value, onChange }) {
  const c = countBuckets(rows);
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-5">
      {BUCKETS.map((b) => (
        <button key={b.key} type="button" onClick={() => onChange(b.key)}
          className={`rounded-xl border px-3 py-2.5 text-left transition-colors ${value === b.key ? "border-black bg-black text-white" : "border-slate-200 bg-white hover:border-slate-400"}`}>
          <div className={`text-[11px] font-semibold uppercase tracking-wider ${value === b.key ? "text-white/70" : "text-slate-500"}`}>{b.label}</div>
          <div className="mt-0.5 font-mono text-xl font-bold tabular-nums">{c[b.key]}</div>
        </button>
      ))}
    </div>
  );
}
